module.exports = __webpack_public_path__ + "img/google-sheets.ba48a568.png";